import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { useI18n } from "../../i18n/LanguageContext";
import { Reveal, Eyebrow, staggerParent, staggerChild } from "./Reveal";

export const Terms = () => {
  const { t } = useI18n();
  return (
    <section className="relative py-24 md:py-32" data-testid="terms-section">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <div className="text-center mb-14">
          <Reveal className="flex justify-center"><Eyebrow>{t.terms.eyebrow}</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display font-bold text-4xl md:text-5xl tracking-tight">{t.terms.title}</h2>
          </Reveal>
        </div>

        <motion.div
          variants={staggerParent}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="grid grid-cols-1 md:grid-cols-2 gap-4"
        >
          {t.terms.items.map((item, i) => (
            <motion.div
              key={i}
              variants={staggerChild}
              data-testid={`term-${i}`}
              className="flex items-start gap-4 rounded-2xl border border-white/[0.06] bg-[#0a0e14] p-6 hover:border-cyan-500/25 transition-colors duration-300"
            >
              <span className="h-7 w-7 shrink-0 rounded-full bg-cyan-500/10 border border-cyan-500/25 grid place-items-center">
                <Check className="h-4 w-4 text-cyan-400" />
              </span>
              <p className="text-sm text-slate-300 leading-relaxed">{item}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
